import React from "react";

import './styles.scss';

import withState from "../../../../../utils/withState";
import {Link, path$} from "../../../../../router";

export default withState((setState, self, onMount) => {
  const getActiveLinkId = (links) => {
    const link = links.find(({link}) => path$.getValue().startsWith(link));
    return (link || {}).id;
  };
  const defaultLinkId = getActiveLinkId(self.props.links) || self.props.links[0].id;

  self.state = {
    ...self.state,
    activeId: defaultLinkId,
  }

  const onClick = (activeId) => () => {
    setState({
      activeId
    });
  }

  return ((state, props) => {
    const {activeId} = state;
    const {links, views} = props;

    const Content = views[activeId] || (() => <span />);

    return (
      <div className="third-layer-menu">
        <div className="third-layer-menu__head">
          {links.map(({id, link, name}) => (
            <Link
              id={id}
              key={id}
              className={
                'third-layer-menu__head-item'
                + (id === activeId ? ' active' : '')
              }
              href={link}
              onClick={onClick(id)}
            >
              {name}
            </Link>
          ))}
        </div>
        <div className="third-layer-menu__content">
          <Content />
        </div>
      </div>
    )
  })
});
